module.exports = "/packs/icon-money-6f9a2d8d53e3db673da0f467ab8348eb.png";